const SiteInfoDetail = () => import('Views/siteInfo/siteInfo-detail');

export default[
  { path: '/service-detail/:id', component: SiteInfoDetail },
];



// WEBPACK FOOTER //
// ./src/router/service.js